fx.ns("repositories", class PhotosRepository extends fx.ModelArray {

    constructor(model)
    {
        super(model);

        this._extracting = false;
        this._reaffecting = false;

        this.endpoint = "/app/photos";
    }

    get extracting()
    {
        return this._extracting;
    }

    set extracting(val)
    {
        this.event("photo-extracted-updated");
        
        this._extracting = val;
    }

    get reaffecting()
    {
        return this._reaffecting;
    }

    get processing()
    {
        let photo = this.filter( photo => photo.processing );
        return !!photo; //this.last.processing;
    }

    get count()
    {
        return this.active.length;
    }

    
    get active()
    {
        return this.filter(function(photo) { return !photo.deleted; });
    }
    
    get iaEnabled()
    {
        return this.every(function(photo){ return photo.faces != null;});
    }

    get available()
    {
        return this.filter( photo => /*!photo.isHeic &&*/ !photo.deleted );
    }

    get containHeic()
    {
        return this.filter( photo => photo.isHeic).length > 0;
    }
   
    get emptyMedia()
    {
        if (!this._emptyMedia)
            this._emptyMedia = new models.EmptyMedia();

        return this._emptyMedia;
    }

    // --------------------------------------- //
    
    use(id, use, history)
    {
        let photo = this.find({id : id});

        if (!photo)
            photo = this.find({oldid : id});
        
        if (photo) // photo can be deleted 
            //photo.number = use ? (photo.number + 1) : Math.max(0, photo.number - 1);
            photo.update( {number : use ? (photo.number + 1) : Math.max(0, photo.number - 1)}, {history : !!history} );				
    }

    /*updateUrls(creationid, accountid)
    {
        this.post(  { 
            action:"getAll", 
            creationid : creationid,
            accountid : accountid
        }, 
        this._updateUrls);
    }

    _updateUrls(data)
    {
        if (data.error)
        {
            this.event("update-url-error")
        }
        else
        {
            for (let i = 0; i < data.length; i++)
            {
                let photo = this.find({id : data[i].id});
                if (photo)
                    photo.update({
                                    thumb : Utils._fixURL(data[i].thumb),
                                    url  : Utils._fixURL(data[i].url),
                                    light_url : Utils._fixURL(data[i].light_url)
                                });
                    
            }

            this.event("update-url-complete")
        }
    }*/

    updateAccountId(creationid, newAccountId)
    {
        for (let i = 0; i < this.length; i++)
            this.getItemAt(i).accountid = newAccountId;

        //this.updateUrls(creationid, newAccountId);
    }

    cancel(id) {
		this.post(
			{
				action: "cancel",
				id: id
			},
			this._canceled
		);
	}

	_canceled(data) {

	}

    reaffectPhotos(creationid, accountid, oldaccountid)
    {
        this._reaffecting = true;

        this.post(
            {
                action: "reaffectphotos",
                creationid : creationid,
                accountid: accountid,
                oldaccountid : oldaccountid
            },
            this._reaffectPhotos
        );
    }

    _reaffectPhotos(data)
    {
        if (!data.error)
        {
            for (let i = 0; i < data.length; i++)
            {
                let photo = this.find({id : data[i].id});
                if (photo)
                    photo.update({
                                    accountid : data[i].accountid,
                                    thumb : Utils._fixURL(data[i].thumb),
                                    url  : Utils._fixURL(data[i].url),
                                    light_url : Utils._fixURL(data[i].light_url)
                                });

            }

            //this.event("update-url-complete")
        }

        this._reaffecting = false;

        this.event("reaffecting-complete")
    }
   
});